import { forEach } from 'lodash'

import { batchOpacityRevealAnimation } from './shared'
import { Animation } from '@/types'

export const gridRevealAnimation = ({ context, reverse }: Animation) => {
  const cards = context.selector?.('[data-motion-card]')

  let cardsBatchAnimation: ScrollTrigger[]
  if (cards.length > 0) {
    cardsBatchAnimation = batchOpacityRevealAnimation({
      targets: cards,
      reverse,
      stagger: {
        amount: 0.12
      }
    })
  }

  return () => {
    forEach(cardsBatchAnimation || [], (animation) => animation.kill())
  }
}
